import { registerWeapon } from './registry';
import { DEFAULT_CRATER } from '../terrain/crater-shapes';

export const SEEKER = registerWeapon({
  id: 'seeker',
  name: 'Seeker',
  description: 'Homes in on nearest opponent. Locks on and goes hypersonic.',
  tier: 'RARE',
  rarity: 'rare',
  projectileRadius: 6,
  projectileSpeed: 0.65,
  color: 0xff44ff,
  gravity: 0.08,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 32,
  blastRadius: 80,
  knockbackMult: 0.07,
  knockbackRadius: 1.2,
  shakeIntensity: 2.5,
  particleScale: 1.2,
  craterShape: DEFAULT_CRATER,
  onTick(proj, state, fx) {
    proj.behaviorState.flightFrames = (proj.behaviorState.flightFrames || 0) + 1;

    // Find nearest alive opponent
    let nearestDist = Infinity;
    let nearestAngle = 0;
    for (let i = 0; i < state.players.length; i++) {
      if (i === proj.owner) continue;
      const p = state.players[i];
      if (!p.alive) continue;
      const dx = p.x - proj.x;
      const dy = p.y - proj.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < nearestDist) {
        nearestDist = dist;
        nearestAngle = Math.atan2(dy, dx);
      }
    }

    if (nearestDist === Infinity) return null;

    const currentAngle = Math.atan2(proj.vy, proj.vx);
    let diff = nearestAngle - currentAngle;
    while (diff > Math.PI) diff -= Math.PI * 2;
    while (diff < -Math.PI) diff += Math.PI * 2;

    const locked = proj.behaviorState.locked;

    if (!locked) {
      // Seeking phase — gentle turn toward target
      const turnRate = 0.03;
      const turn = Math.max(-turnRate, Math.min(turnRate, diff));
      const speed = Math.sqrt(proj.vx * proj.vx + proj.vy * proj.vy);
      const newAngle = currentAngle + turn;
      proj.vx = Math.cos(newAngle) * speed;
      proj.vy = Math.sin(newAngle) * speed;

      // Lock on: after 25 frames, when pointed within 0.2 rad of target
      if (proj.behaviorState.flightFrames > 25 && Math.abs(diff) < 0.2) {
        proj.behaviorState.locked = 1;
        // Hypersonic boost — triple the speed
        const boostSpeed = speed * 3;
        const lockAngle = Math.atan2(proj.vy, proj.vx);
        proj.vx = Math.cos(lockAngle) * boostSpeed;
        proj.vy = Math.sin(lockAngle) * boostSpeed;
        // Kill gravity — locked missile flies straight
        proj.weapon = { ...proj.weapon, gravity: 0 };
        // Smoke ring effect at lock-on point
        fx.push({ type: 'particles', method: 'spawnRichExplosion', args: [proj.x, proj.y, 0xcccccc, 30, 0.4] });
        fx.push({ type: 'screen_shake', intensity: 3, decay: 0.8 });
      }
    } else {
      // Locked phase — tighter tracking, maintains speed, ignores wind
      const turnRate = 0.05;
      const turn = Math.max(-turnRate, Math.min(turnRate, diff));
      const speed = Math.sqrt(proj.vx * proj.vx + proj.vy * proj.vy);
      const newAngle = currentAngle + turn;
      proj.vx = Math.cos(newAngle) * speed;
      proj.vy = Math.sin(newAngle) * speed;
      // Counteract wind — hypersonic missile flies true
      if (state.wind !== 0) {
        proj.vx -= state.wind;
      }
    }

    return null;
  },
});
